import React, { useEffect, useRef, useState } from "react"
import Geosuggest from "react-geosuggest"
import { useTranslation } from "react-i18next"
import { connect } from "react-redux"
import ReactSVG from "react-svg"
import CALogo from "../../../../images/CA_CheckIcon.svg"
import { isEmpty, min, partition } from "lodash"
import DiscountRibbon from "./DiscountRibbon"
import SelectShops from "./SelectShop"
import ShopFilters from "./ShopFilters"
import { ACTIVE_VIEWS, PRICE } from "../../../../shared_component/constants/checkout"
import { DISTANCE } from "../../../../v1/components/ShopSearch/SelectShop"
import { RATING_TAG } from "../../../../v1/constants/shops"
import MapBox from "../../MapBox/MapBox"
import { getAffiliationShops } from "../../../../v1/actions/affiliations"
import store from "../../../../shared_component/utils/configureStore"
import Notifications from "../../../../v1/components/Notifications"
import { USE_CURRENT_LOCATION } from "../../../../v1/constants/mapbox"
import { Dimmer, Loader, Modal } from "semantic-ui-react"
import { routerPaths } from "../../../../v1/constants/paths"
import { withRouter } from "react-router-dom"
import {
  gaJSON,
  shopSelectedEvents,
  trackFirebaseAnalytics
} from "../../../../shared_component/utils/googleAnalyticsHelpers"
import { getShopAddress, getShopName } from "../../../../v1/helpers/shopHelpers"
import { trackEvent } from "../../../../shared_component/utils/segmentAnalytics"
import { clearPromotionParam } from "../../../../v1/actions/promotion"
import { updateCart, updateInfo } from "../../../../v1/actions/user"
import { sortByAttr } from "../../../../shared_component/utils/arrayHelpers"
import { suggestGeoSuggestClick } from "../../../../v1/CarAdvise2/helpers/geoLocationHelper"
import { CA, USA } from "../../../../v1/constants/states"
import { AddOilChangeService } from "../common"
import ConfirmServices from "./ConfirmServices"
import { getUpdatedCart } from "../../../../v1/helpers/orderHelpers"
import SplitClient from "../../../../v1/components/Config/SplitClient"
import InfoIcon from "../../../../images/info-Icon.svg"
import { getSubdomain } from "../../../../v1/components/Config/StylesheetInjector"
import {
  INSTACART,
  INSTACART_CA_NO_TIER,
  INSTACART_CANADA
} from "../../../../v1/constants/affiliations"
import LetsScheduleAppointmentModal from "../LetsScheduleAppointmentModal"
import { serviceRequestTypes } from "../../../constants"
import moment from "moment/moment"
import { CART_EVENTS, DATE_TIME_FORMAT, WALK_IN_TIME } from "../../../../v1/constants/application"
import { BASIC } from "../../../../v1/constants/tires"

const TOTAL_SHOPS = "32,000"
const ShopSelection = ({
  user,
  history,
  cart,
  activeVehicle,
  promoCode,
  getAffiliationShops,
  updateInfo,
  promotions,
  order,
  serviceRequestType,
  props
}) => {
  const { t } = useTranslation(["affiliationShopSelection", "dashboardMapComponent"])

  const [searchLocation, setSearchLocation] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [affiliationShops, setAffiliationShops] = useState(null)
  const [ratingFiltersApplied, setRatingFilterApplied] = useState([])
  const [typeFiltersApplied, setTypeFilterApplied] = useState([])
  const [sortingType, setSortingType] = useState(DISTANCE)
  const [isSortOpen, setIsSortOpen] = useState(false)
  const [isFilterOpen, setIsFilterOpen] = useState(false)
  const [selectedShop, setSelectedShop] = useState(null)
  const [activeView, setActiveView] = useState(ACTIVE_VIEWS.LIST)
  const [open, setOpen] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [showConfirmServices, setShowConfirmServices] = useState(false)
  const isOilChangeService = localStorage.getItem("isOilChangeService") === "true" || false
  const [showValvolineShopsAtTop, setShowValvolineShopsAtTop] = useState(null)
  const [inputValue, setInputValue] = useState(null)
  const geoSuggestRef = useRef(null)
  const [openLetsSchedule, setOpenLetsSchedule] = useState(false)

  useEffect(async () => {
    const valvoline = await SplitClient.getTreatment("show_valvoline_on_top_shop_list", user)
    setShowValvolineShopsAtTop(valvoline.show_valvoline_on_top_shop_list === "on")
  }, [])

  useEffect(() => {
    const fetchData = async () => {
      if (isOilChangeService) {
        await AddOilChangeService({
          store,
          vehicle: activeVehicle,
          setIsSubmitting,
          t,
          cart
        })
      }

      const shopSearchPayload = JSON.parse(localStorage.getItem("shopSearchPayload"))

      if (cart.shop && shopSearchPayload) {
        fetchShops(shopSearchPayload)
        return
      }

      if (user.zip) {
        fetchShops({ zip: user.zip })
      }
    }

    fetchData()
  }, [isOilChangeService])

  useEffect(() => {
    trackFirebaseAnalytics({
      event: gaJSON.EtoB_preferred_shop_view,
      params: {
        viewType: activeView
      }
    })
  }, [activeView])

  useEffect(() => {
    trackFirebaseAnalytics({
      event: gaJSON.EtoB_shops_sorting_type,
      params: {
        sortType: sortingType
      }
    })
  }, [sortingType])

  useEffect(() => {
    trackFirebaseAnalytics({
      event: gaJSON.EtoB_rating_filter_applied,
      params: {
        rating: ratingFiltersApplied
      }
    })
  }, [ratingFiltersApplied])

  useEffect(() => {
    trackFirebaseAnalytics({
      event: gaJSON.EtoB_type_filter_applied,
      params: {
        filterType: typeFiltersApplied
      }
    })
  }, [typeFiltersApplied])

  const addorRemoveFilterItem = (value, filterType) => {
    if (filterType === RATING_TAG) {
      setRatingFilterApplied((prevRatings) => {
        let updatedRatings = [...prevRatings]
        const index = updatedRatings.findIndex((i) => i === value)

        if (index > -1) {
          updatedRatings = []
        } else {
          updatedRatings = []
          if (value === 2) updatedRatings.push(2, 3, 4, 5)
          else if (value === 3) updatedRatings.push(3, 4, 5)
          else if (value === 4) updatedRatings.push(4, 5)
          else if (value === 5) updatedRatings.push(5)
        }
        return updatedRatings
      })
    } else {
      setTypeFilterApplied((prevTypes) => {
        let updatedTypes = [...prevTypes]
        const index = updatedTypes.findIndex((i) => i === value)

        if (index > -1) {
          updatedTypes.splice(index, 1)
        } else {
          updatedTypes.push(value)
        }
        return updatedTypes
      })
    }
  }

  const clearAllFilters = () => {
    setRatingFilterApplied([])
    setTypeFilterApplied([])
    setIsFilterOpen(false)
  }

  const updateSortingType = (value) => {
    setSortingType(value.length ? value : DISTANCE)
    getFuelStationsDataWithSorting()
  }

  const onGeoSuggestClick = (suggest) => {
    trackFirebaseAnalytics({
      event: gaJSON.EtoB_select_shop_location_search,
      params: {
        term: suggest.label
      }
    })
    const apiPayload = {
      latitude: suggest?.location?.lat || "41.4248924",
      longitude: suggest?.location?.lng || "-87.7726651"
    }
    setSearchLocation({
      lat: apiPayload.latitude,
      lng: apiPayload.longitude
    })
    fetchShops(apiPayload)
  }

  const servicesParam = () => {
    const updatedCartData = getUpdatedCart(user, order, props)
    const addedServices = updatedCartData.cart.order_services
    const services = addedServices.map((sd) => {
      return { position: sd.position, service_definition_id: sd.id }
    })

    return JSON.stringify(services)
  }
  const fetchShops = async (apiPayload, walk_in = true) => {
    setIsLoading(true)
    try {
      if (cart.cart_type == serviceRequestTypes.WALK_IN && walk_in) {
        apiPayload.booking_type = JSON.stringify([serviceRequestTypes.WALK_IN])
      }
      localStorage.setItem("shopSearchPayload", JSON.stringify(apiPayload))
      const res = await getAffiliationShops({
        ...apiPayload,
        vehicle_id: user.activeVehicleId,
        services_requested: servicesParam()
      })
      if (res.error || res.result.errors) {
        store.dispatch(
          Notifications.error({
            title: t("settings:errorTitle"),
            message: res.error || res.result.errors,
            position: "tr",
            autoDismiss: 5,
            action: {
              label: "Dismiss"
            }
          })
        )
        return
      }
      setAffiliationShops(res?.result || [])
    } catch (error) {
      console.log("Error in fetchShops", error)
    } finally {
      setIsLoading(false)
    }
  }

  const expandCompressClick = () => {
    setIsSortOpen(false)
    // setIsSortOpenModal(false)
    handleModel()
  }

  const handleModel = () => {
    setOpen((prev) => !prev)
  }

  const handleSearchFuelStation = (suggest) => {
    setSearchLocation({
      lat: suggest?.location?.lat,
      lng: suggest?.location?.lng,
      isUserCurrentLocation: suggest?.name === USE_CURRENT_LOCATION
    })
  }

  const getFuelStationsDataWithSorting = () => {
    let filteredShops = affiliationShops?.length > 0 ? [...affiliationShops] : []

    // Apply rating filter
    if (!isEmpty(ratingFiltersApplied)) {
      const minRating = +min(ratingFiltersApplied).toFixed(2)
      filteredShops = filteredShops?.filter((shop) => +shop.average_rating >= minRating)
    }

    // Apply type filters
    if (!isEmpty(typeFiltersApplied)) {
      filteredShops = filteredShops.filter((shop) => {
        const { company } = shop || {}
        return (
          (typeFiltersApplied?.includes("walk_in") && company?.walk_ins_only) ||
          (typeFiltersApplied?.includes("appointment") && !company?.walk_ins_only) // Placeholder for additional appointment filtering logic
        )
      })
    }

    let shops = []

    if (sortingType === PRICE) {
      let partitioned = partition(
        filteredShops,
        (s) => s?.price_estimates?.[0]?.shop_price_estimate != null
      )
      let withPrices = partitioned[0]
      let nullPrices = partitioned[1]

      let sorted = withPrices?.sort(
        (a, b) =>
          a.price_estimates[0].shop_price_estimate - b.price_estimates[0].shop_price_estimate
      )
      sorted = sorted.concat(sortByAttr(nullPrices, DISTANCE))

      if (showValvolineShopsAtTop) {
        sorted = sorted.sort((a, b) =>
          a.company.name.toUpperCase() === "VALVOLINE" && a.distance <= 5 ? -1 : 1
        )
      }

      shops = sorted
    } else {
      let sorted = sortByAttr(filteredShops, DISTANCE)

      if (showValvolineShopsAtTop) {
        sorted = sorted.sort((a, b) =>
          a.company.name.toUpperCase() === "VALVOLINE" && a.distance <= 5 ? -1 : 1
        )
      }

      shops = sorted
    }

    const sponsoredShops = shops?.filter((shop) => {
      return shop?.shop_featured === true
    })

    const otherShops = shops?.filter((shop) => {
      return !sponsoredShops.includes(shop)
    })

    return [...sponsoredShops, ...otherShops]
  }

  // useEffect(() => {
  //   suggestGeoSuggestClick()
  // }, [])

  const handleIconClick = (shop) => {
    setSelectedShop(shop)
  }
  const isComparePriceFlow = localStorage.getItem("isComparePriceFlow") === "true"

  const handleShopSelect = async (shop, moveToContactInfo) => {
    if (!user.lastName || !user.zip) {
      await updateInfo({
        zip: !user.zip ? shop.zip : user.zip,
        lastName: !user.lastName ? "" : user.lastName
      })
    }
    setIsSubmitting(true)
    let opts = {
      successCallback: async (response) => {
        await shopSelectedEvents({ response, shop, activeVehicle })
        await trackEvent("click-service-center", {
          shopAddress: getShopAddress(response.shop),
          shopCity: response.shop && response.shop.city,
          shopName: getShopName({
            shop: response.shop,
            company: response.shop && response.shop.company
          }),
          shopId: response.shop && parseInt(response.shop.id),
          eventSourceName: "Checkout_2.0",
          cartType: cart.cart_type || "scheduled"
        })
        store.dispatch(clearPromotionParam())
      }
    }
    if (promoCode) opts.promoCode = promoCode

    const events = [{ event: "set_shop", shop_id: shop.id }]

    if (serviceRequestType === serviceRequestTypes.WALK_IN) {
      const selectedDate = sessionStorage.getItem("walkInDate")
      const walkInDate = moment(selectedDate).set({ hour: "3", minute: "00" })
      const date_str = walkInDate.format(DATE_TIME_FORMAT.MM_DD_YYYY_H_M)
      events.push({ event: CART_EVENTS.SET_WALK_IN, appointment_datetime: date_str })
    }

    const response = await store.dispatch(updateCart(events, undefined, undefined, true, opts))

    if (response && response().result) {
      setSelectedShop(shop)
      setIsSubmitting(false)

      if (isComparePriceFlow) {
        if (moveToContactInfo) {
          const subtotal = cart.order_services.reduce((sum, service) => {
            const rawPrice = service?.price_estimate?.shop_price_estimate
            const price = parseFloat(rawPrice)
            return sum + (!isNaN(price) ? price : 0)
          }, 0)

          const comparePriceData = {
            selectedServices: cart.order_services || [],
            selectedShopId: shop.id || 0,
            subTotal: subtotal
          }

          localStorage.setItem("comparePriceData", JSON.stringify(comparePriceData))

          history.push({
            pathname: routerPaths.updateUser
          })

          return
        }

        setShowConfirmServices(true)
        return
      }
      const isCanadaBasic =
        user.country === CA && (user.membership?.plan_name === BASIC || user.membership === null)
      const isInstacartCanada = user.affiliation.root_reference_id === INSTACART_CANADA

      if (isCanadaBasic) {
        history.push({ pathname: routerPaths.activateMembership })
        return
      }

      if (serviceRequestType === serviceRequestTypes.WALK_IN) {
        history.push({
          pathname: routerPaths.reviewRequest
        })
        return
      }

      history.push({
        pathname: routerPaths.appointment
      })
    }
    if (response().error) {
      setSelectedShop(null)
      setIsSubmitting(false)
    }
  }

  const onLocationPermissionError = () => {
    store.dispatch(
      Notifications.error({
        title: t("settings:errorTitle"),
        message: "Location permission is needed to continue. Please enable it in settings.",
        position: "tr",
        autoDismiss: 5,
        action: {
          label: "Dismiss"
        }
      })
    )
  }

  const handleServiceType = async (serviceType) => {
    setIsSubmitting(true)
    try {
      setOpenLetsSchedule(false)
      await store.dispatch(updateCart(null, activeVehicle.id, null, undefined, {}, serviceType))
      setIsSubmitting(false)
      const shopSearchPayload = JSON.parse(localStorage.getItem("shopSearchPayload"))
      if (shopSearchPayload) {
        fetchShops(shopSearchPayload, false)
      }
      trackFirebaseAnalytics({
        event: gaJSON.pivot_modal_interaction,
        params: {
          user_choice: "switch_to_scheduled"
        }
      })
    } catch (e) {
      setOpenLetsSchedule(false)
      store.dispatch(
        Notifications.error({
          title: t("errorLbl"),
          message: e.toString(),
          position: "tr",
          autoDismiss: 5,
          action: {
            label: "Dismiss"
          }
        })
      )
      setIsSubmitting(false)
    }
  }

  const handleClear = () => {
    setInputValue("")
    if (geoSuggestRef.current) {
      geoSuggestRef.current.clear()
      geoSuggestRef.current.focus()
      setAffiliationShops([])
    }
  }

  const isInstacartOilChangePromo = promotions?.some(
    (promotion) => promotion?.name?.toLowerCase() === "instacart discount applied"
  )
  const isInstacartUser = [INSTACART, INSTACART_CANADA]?.includes(getSubdomain())

  if (showConfirmServices) {
    return <ConfirmServices onGoBack={() => setShowConfirmServices(false)} />
  }

  return (
    <div
      className={`instacart-shop-selection ${
        isEmpty(affiliationShops) ? "" : "shop-section-height"
      }`}
    >
      {cart.cart_type === serviceRequestTypes.WALK_IN && (
        <p className="walk-in-shop-header">
          Available shops {user.country === USA && "for walk-ins"}
        </p>
      )}
      <div className="section-sticky">
        {activeView !== ACTIVE_VIEWS.MAP && cart.cart_type !== serviceRequestTypes.WALK_IN && (
          <p className="search-by">{t("searchNearByOilShops")}</p>
        )}

        {activeView !== ACTIVE_VIEWS.MAP && (
          <div style={{ position: "relative" }}>
            <Geosuggest
              ref={geoSuggestRef}
              onSuggestSelect={(suggest) =>
                suggestGeoSuggestClick(suggest, onGeoSuggestClick, onLocationPermissionError)
              }
              placeholder={t("geoPlaceholder")}
              types={["geocode"]}
              country={user.country}
              ignoreTab={true}
              className="geosuggestContainerNew shop-selection"
              suggestsClassName="search-suggests-list"
              suggestItemClassName="search-suggest-item"
              inputClassName={`searchFldShop smaller-width`}
              suggestItemActiveClassName="search-suggest-item-active"
              suggestsHiddenClassName="search-suggests-list-hidden"
              fixtures={[{ label: t("dashboardMapComponent:use-current-location"), custom: true }]}
              autoComplete="off"
              onChange={(value) => setInputValue(value)}
              style={{ width: "100% !important" }}
            />
            {inputValue && (
              <button
                onClick={handleClear}
                style={{
                  position: "absolute",
                  right: "0px",
                  top: "22px",
                  transform: "translateY(-50%)",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  fontSize: "1em",
                  color: "#666",
                  zIndex: 9999
                }}
                aria-label="Clear input"
              >
                ✕
              </button>
            )}
          </div>
        )}

        {/* Shop Filters */}
        {affiliationShops && (
          <div
            className={`instacart-shop-filters-box ${
              activeView === ACTIVE_VIEWS.MAP ? "instacart-shop-filters-box-map" : ""
            } `}
          >
            <ShopFilters
              setActiveView={setActiveView}
              activeView={activeView}
              ratingFiltersApplied={ratingFiltersApplied}
              typeFiltersApplied={typeFiltersApplied}
              addorRemoveFilterItem={addorRemoveFilterItem}
              clearAllFilters={clearAllFilters}
              sortingType={sortingType}
              setIsSortOpen={setIsSortOpen}
              setIsFilterOpen={setIsFilterOpen}
              isSortOpen={isSortOpen}
              isFilterOpen={isFilterOpen}
              updateSortingType={updateSortingType}
              setSelectedShop={setSelectedShop}
              setSortingType={setSortingType}
            />
          </div>
        )}

        {!isComparePriceFlow &&
          affiliationShops &&
          promotions.length > 0 &&
          isInstacartUser &&
          isInstacartOilChangePromo && (
            <div className="discount-ribbon-container">
              <DiscountRibbon title={t("discountOnCheckout")} user={user} />
            </div>
          )}
        {isComparePriceFlow && !isLoading && (
          <DiscountRibbon
            title="Price estimates shown are based on your selected vehicle."
            user={user}
            src={InfoIcon}
          />
        )}
      </div>

      {cart.cart_type === serviceRequestTypes.WALK_IN && user.country !== CA && (
        <div className="appointment-modal-info">
          This list features shops that specialize in express services. Looking for a full-service
          center?{" "}
          <p className="appointment-modal" onClick={() => setOpenLetsSchedule(true)}>
            Schedule an appointment.
          </p>
        </div>
      )}

      {/* Shop list and Map view */}
      <div
        className={`instacart-shop-selection-list ${
          !isLoading && affiliationShops && affiliationShops.length === 0 ? "no-shops-found" : ""
        }`}
      >
        {activeView === ACTIVE_VIEWS.LIST ? (
          getFuelStationsDataWithSorting()?.map((shop) => (
            <SelectShops
              handleShopSelection={handleShopSelect}
              key={shop.id}
              selectedShop={selectedShop}
              shop={shop}
              isSubmitting={isSubmitting}
            />
          ))
        ) : (
          <MapBox
            shops={affiliationShops || []}
            isLoading={isLoading}
            expandCompressClick={expandCompressClick}
            onSuggestSelect={handleSearchFuelStation}
            searchLocation={searchLocation}
            handleIconClick={handleIconClick}
            selectedItem={selectedShop}
            isShopSelection={true}
            mapSelectComponent={
              <SelectShops
                handleShopSelection={handleShopSelect}
                shop={selectedShop}
                selectedShop={selectedShop}
                isSubmitting={isSubmitting}
              />
            }
          />
        )}
        {!isLoading && affiliationShops && affiliationShops.length === 0 && (
          <p>{t("noShopsFound")}</p>
        )}
      </div>

      {/* Placeholder */}
      {(isLoading || !affiliationShops) && (
        <div className="shop-selection-placeholder">
          <ReactSVG className={`ca-logo ${isLoading ? "ca-logo-loading" : ""}`} src={CALogo} />
          <p className="placeholder-text">
            {isLoading
              ? t("lookingForBestDeals")
              : t("searchShops", {
                  SHOPS: TOTAL_SHOPS
                })}
          </p>
        </div>
      )}

      {open && (
        <Modal
          open={open}
          onClose={handleModel}
          onOpen={handleModel}
          className="fuel-station-modal"
        >
          <div className="modal-container">
            <div className="fuel-station-box">
              <div className="shop-list-section">
                {getFuelStationsDataWithSorting()?.map((shop) => (
                  <SelectShops
                    handleShopSelection={handleShopSelect}
                    key={shop.id}
                    selectedShop={selectedShop}
                    shop={shop}
                    isSubmitting={isSubmitting}
                  />
                ))}
              </div>
              <div className="map-box-section">
                <MapBox
                  shops={affiliationShops || []}
                  isLoading={isLoading}
                  isExpanded={open}
                  isShopSelection={true}
                  containerClassName="map-modal"
                  wantExpandCollapse={false}
                  expandCompressClick={expandCompressClick}
                  onSuggestSelect={handleSearchFuelStation}
                  searchLocation={searchLocation}
                  handleIconClick={handleIconClick}
                  selectedItem={selectedShop}
                  mapSelectComponent={
                    <SelectShops
                      handleShopSelection={handleShopSelect}
                      shop={selectedShop}
                      selectedShop={selectedShop}
                      isSubmitting={isSubmitting}
                    />
                  }
                />
              </div>
            </div>
          </div>
          {isSubmitting && (
            <Dimmer active>
              <Loader />
            </Dimmer>
          )}
        </Modal>
      )}

      {isSubmitting && (
        <Dimmer className="shop-select-dimmer" active>
          <Loader />
        </Dimmer>
      )}

      <LetsScheduleAppointmentModal
        open={openLetsSchedule}
        onClose={() => setOpenLetsSchedule(false)}
      />
    </div>
  )
}

const mapStateToProps = (state, props) => {
  let user = state.user
  let activeVehicle = user.vehicles && user.vehicles.find((v) => v.id == user.activeVehicleId)
  let cart
  const order =
    activeVehicle &&
    activeVehicle.id &&
    (user.active_orders || []).find((o) => o.vehicle_id === activeVehicle.id)
  let updatedCartData = getUpdatedCart(user, order, props)
  if (updatedCartData) {
    cart = updatedCartData.cart
  } else {
    cart = user.active_carts && user.active_carts.find((c) => c.vehicle_id == user.activeVehicleId)
  }
  const promotionData = state.promotionData
  const serviceRequestType = user.serviceRequestType || ""
  return {
    promoCode: promotionData.promoCode,
    user,
    cart: cart || {},
    activeVehicle,
    promotions: promotionData.customerPromotions || [],
    order,
    props,
    serviceRequestType
  }
}

export default withRouter(
  connect(mapStateToProps, { getAffiliationShops, updateInfo })(ShopSelection)
)
